// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"30":"newsAndEvents","242":"solution","415":"details","562":"brand","594":"about","806":"development"}[chunkId] + "." + {"30":"90515861","242":"d16d3311","415":"00dad9d1","562":"e76bb1a7","594":"2163d181","806":"2f3fbdb5"}[chunkId] + ".css";
};